// ============================================================
// Projects · Settings — per-project settings entry. Identity,
// status, archival. The mutation surface is intentionally narrow
// while the project schema is still settling; the screen exists
// so the project journey is complete.
// ============================================================

import { useState } from 'react'
import { SHELL_TOKENS, text } from '../../shell/styles'
import EmptyState from '../../components/EmptyState'
import ProjectSurface from './ProjectSurface'

export default function ProjectSettings() {
  const [archived, setArchived] = useState(false)
  return (
    <ProjectSurface
      kicker="PROJECT · SETTINGS"
      title="Project Settings"
      description="Identity, lifecycle, and archival."
    >
      <div
        style={{
          padding: '18px 20px',
          borderRadius: 12,
          background: SHELL_TOKENS.surface,
          border: `1px solid ${SHELL_TOKENS.border}`,
          marginBottom: 18,
        }}
      >
        <div
          style={{
            ...text.kicker,
            fontSize: 8,
            letterSpacing: '0.18em',
            color: SHELL_TOKENS.inkFaint,
            marginBottom: 8,
          }}
        >
          LIFECYCLE
        </div>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            fontSize: 12,
            color: SHELL_TOKENS.inkDim,
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={archived}
            onChange={(e) => setArchived(e.target.checked)}
          />
          Archive this project
        </label>
      </div>

      <EmptyState
        title="More settings landing soon"
        body="Identity edits, member assignment, and archival controls will expand here as the project surface matures."
      />
    </ProjectSurface>
  )
}
